/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        // add custom media query sizes for Foundation Interchange
        Foundation.Interchange.SPECIAL_QUERIES.smallretina = 'only screen and (min-width: 1px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min-resolution: 192dpi), only screen and (min-width: 1px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.mediumretina = 'only screen and (min-width: 641px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 641px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 641px) and (min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min-resolution: 192dpi), only screen and (min-width: 641px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.largeretina = 'only screen and (min-width: 1025px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1025px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min-resolution: 192dpi), only screen and (min-width: 1025px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.xlargeretina = 'only screen and (min-width: 1921px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1921px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min-resolution: 192dpi), only screen and (min-width: 1921px) and (min-resolution: 2dppx)';

        // init Foundation JavaScript
        $(document).foundation(); 

        // add plz pattern for Foundation Abide
        Foundation.Abide.defaults.patterns.plz = /^([0]{1}[1-9]{1}|[1-9]{1}[0-9]{1})[0-9]{3}$/;

        // set default Sticky size for Foundation Sticky
        Foundation.Sticky.defaults.stickyOn = 'large';

        // Mobile Menu
        Foundation.DropdownMenu.defaults.closeOnClick = true;

        // change Menu class on scroll
        $(window).scroll(function() {
          if ($(this).scrollTop() > 50) {
            $('body').addClass('solid-header');
          } else {
            $('body').removeClass('solid-header');
          }
        });

        // add no-touch class for desktop browsers
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        if (!touchsupport) { 
            document.documentElement.className += " no-touch ";
        }

        // Toggle menu
        $('[data-off-canvas]').on("opened.zf.offcanvas", function(e) {
          $('#toggle-menu').addClass('open');
          $('#main-header').addClass('toggle-menu-open');
          $('body').addClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').addClass('active');
        });
        $('[data-off-canvas]').on("closed.zf.offcanvas", function(e) {
          $('#toggle-menu').removeClass('open');
          $('#main-header').removeClass('toggle-menu-open');
          $('body').removeClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').removeClass('active');          
        });

        $('#toggle-menu .menu-item-has-children > a').click(function(){
           var i = 0;
           var parent = $(this).parent();
           $('#toggle-menu ul > li').each(function(){
             if($('#toggle-menu ul > li').index(parent)!==i){
               $(this).removeClass('open');
               $(this).find('*').removeClass('open');
             }
             i++;
           });
           $(this).parent().toggleClass('open');
           $(this).toggleClass('open');
           $(this).siblings('.foldable-content').toggleClass('open');
           return false;
        });     

        // Smooth scrolling
        if(window.location.hash) {
          $('html, body').animate({
              scrollTop: $(window.location.hash).offset().top - $('header').height() + 'px'
          }, 1000);
        }         

        // Scrolldown Button scrolling
        $('.scrolldown-button').click(function(){
          var nextSection = $(this).closest('section').next();

          $('html, body').animate({
              scrollTop: nextSection.offset().top
          }, 1000);            
        });
  
        // hover siblings
        $(".sibling-hover").hover(function() {
            $(this).siblings(".sibling-hover").addClass("sibling-hovered");
        }, function() {
            $(this).siblings(".sibling-hover").removeClass("sibling-hovered");
        });       

        // landscape image animation
        function loop_landscape() {
            $('#landscape').animate ({
                'background-position': '-=4933',
            }, 30000, 'linear', function() {
                loop_landscape();
            });            
        }

        // Helper for owned car select
        $('#owned_car_yes_no').change(function () {
        
          var selectedCar = $("#owned_car_yes_no").val();
        
          if ($("#owned_car_yes_no").val() === "ja") {
            $('.owned-car-brand-row').removeClass('hide');
            $('.owned-car-model-row').removeClass('hide');
            $('.owned-car-year-row').removeClass('hide');
            $('#owned_car').prop('required',true);
            $('#owned_car_model').prop('required',true);
            $('#owned_car_year').prop('required',true);            
          } else {
            $('.owned-car-brand-row').addClass('hide');
            $('.owned-car-model-row').addClass('hide');
            $('.owned-car-year-row').addClass('hide');
            $('#owned_car').prop('required',false);
            $('#owned_car_model').prop('required',false);
            $('#owned_car_year').prop('required',false);             
          }
        }); 

        $('#owned_car').change(function () {
        
          var selectedCar = $("#owned_car").val();
        
          if ($("#owned_car").val() !== "") {
        
            $.ajax({   
              type: "POST",
              url: SiteParameters.ajax_url,
              data: ({
                action: 'get_car_models_from_csv',
                selectedcar: selectedCar
              }),              
              success: function(data) {
                var cardata = jQuery.parseJSON(data);
                if (cardata)  {
                  $.each(cardata.resultmodels, function(index, value) {
                    $('#owned_car_model').append(value);
                  });                                         
      
                } else {
                  console.log("no data");
                }
              },
              error: function(data) {
                console.log("Error :( ");
                return false;
              }
            });
          }
        });             

        // dropzone
        if($(".dropzone").length>0) {
           Dropzone.autoDiscover = false;

          var _dropzone = new Dropzone("#uploadForm", { // The camelized version of the ID of the form element
          
            url: SiteParameters.ajax_url,
            autoProcessQueue: false,
            uploadMultiple: false,
            maxFiles: 1,
            timeout: 180000,
            parallelUploads: 100,
            maxFilesize: 20,
            previewsContainer: '#dropzonePreview',
            clickable: '#dropzonePreview',
            acceptedFiles: '.jpeg,.jpg,.gif,.png',
            addRemoveLinks: true,
          
            // The setting up of the dropzone
            sending: function(file, xhr, formData) {
                var formValues = $('form#uploadForm').serializeArray();
                $.each(formValues, function(key, value){
                    formData.append(key,value);
                });
                formData.append( "action", 'submit_dropzonejs');
                formData.append( "post_id", SiteParameters.post_id);
            },            
            init: function () {
                //var myDropzone = this;
        
                var submitButton = document.querySelector('input[type=submit]');
                myDropzone = this; // closure
        
                submitButton.addEventListener("click", function (e) {

                    if (myDropzone.getQueuedFiles().length === 0) {
                      console.log('no queued files');
                      $('.dz-label input').prop('required',true);
                    }
                    else {
                      $('.dz-label input').prop('required',false); 
                    }

                    $("#uploadForm").foundation("validateForm");
                    var invalidFields = $("#uploadForm").find('[data-invalid]');
                    if (invalidFields) {
                      var scrollTo = $('#form-error-message').offset().top;
                  
                      $('html, body').animate({
                        scrollTop: scrollTo
                      }, 400);
                    } 

                    e.preventDefault();
                    e.stopPropagation();

                    //$("#uploadForm").bind("formvalid.zf.abide", function(e,target) {
                    //  myDropzone.processQueue();
                    //});                     
                });
            }
          
          });


          $("#uploadForm").bind("formvalid.zf.abide", function(e,target) {
              //console.log('form valid');
              _dropzone.processQueue();
          });    

          _dropzone.on("addedfile", function() {
            // Show submit button here and/or inform user to click it.
            console.log('files added');
            $('.dz-label input').prop('required',false); 
            $('#uploadForm').foundation('validateInput', $('.dz-label input')); 
            $('.upload-button').addClass('hide');          
            $( '#submit-button' ).addClass('dropzone-has-files');
          }); 
          _dropzone.on("removedfile", function (file) {
            console.log('files removed');
            $('.dz-label input').prop('required',true);  
            $('.upload-button').removeClass('hide');
            $('#uploadForm').foundation('validateInput', $('.dz-label input'));          
          });

          var progressstring = '';
          var progresssubstring = '';

          // Update the total progress bar
          _dropzone.on("totaluploadprogress", function(progress) {
            $("#submit-progress-meter").width(progress + '%'); 
            progressstring = progress+'';
            if (progressstring.indexOf('.')) {
              progresssubstring = progressstring.substr(0, progressstring.indexOf('.'));
            } else {
              progresssubstring = progressstring;
            }

            if (progressstring !== '') {
              $("#submit-progress-text").html(progresssubstring + ' %'); 
              if (progressstring === '100') {
                $("#submit-progress-text").html('saving'); 
              }              
            } else {
              $("#submit-progress-text").html(''); 
            }
          });
          // Hide the total progress bar when nothing's uploading anymore
          _dropzone.on("queuecomplete", function(progress) {
            console.log('queue complete');
            $("#submit-progress-text").html('saving');
          });  
          _dropzone.on("sending", function(file) {
            console.log('sending');
            $(".standard-form").hide();
            $( '#submit-button' ).val( 'Uploading... ');
            $('.progress-wrap').removeClass('hide');
          });                                     
          _dropzone.on("success", function(file,response) {
            //console.log(response);
            var data = jQuery.parseJSON(response);
            $('.progress-wrap').addClass('hide');
            $('#thank-you-message').fadeIn(300);   
            versaTagObj.generateRequest("https://www.landrover-parade.de/teilnehmen/vpv_form-complete");
          });
          _dropzone.on('error', function(file, response) {
            //$(file.previewElement).find('.dz-error-message').text(response);
            console.log(response);
          });
        }   

        // check if submission exists
        function check_for_post(checkpostid) {
          $.ajax({
              type: 'POST',
              url: SiteParameters.ajax_url,
              data: {
                'post_id': checkpostid,
                'action': 'custom_get_post_content'
              }, 
              success: function (result) {
                if(result.error === 'true'){
                  $('.not-found-error').show();
                } else {
                  $('.not-found-error').hide();
                  if ($("#svg-slider-item-id-" + searchNumber).length === 0) {
                    load_more_svg_slides(searchNumber); 
                  } else {
                    var $slickSlide = $('#svg-slider-item-id-' + searchNumber);
                    var slideIndex = $slickSlide.attr('data-slick-index');            
                    $('.svg-slider').slick('slickGoTo', slideIndex, true);
                    $('#svg-slider-item-id-' + searchNumber + ' .overlay-item-link').foundation('show');
                  }
                }
              },
              error: function () {
                console.log("error");
                return false;
              },
              complete: function() { 

              }
          });  

          return false;         
        }

        // Search
        var searchNumber = 0;

        $(".search-form").bind("submit",function(e) {
          e.preventDefault();
          //console.log("submit intercepted");
          return false;
        });    
            
        $(".search-form").bind("formvalid.zf.abide", function(e,target) {
          searchNumber = $(this).find("#searchnumber").val();
          console.log("searchNumber: " + searchNumber);
          check_for_post(searchNumber); 
          $('#searchModal').foundation('close');         
        }); 

        // Load more svg slides
        var currentSvgSlidesPerPage = 20;
        var currentSvgSlideOffset = 0;
        var currentSvgSlidePageNumber = 0;
        var $svgSlidesContainer = $('.svg-slider-wrap');
    
        function load_more_svg_slides(optionalpostid) {
    
          if (!($svgSlidesContainer.hasClass('loading') || $svgSlidesContainer.hasClass('no-more-posts'))) {
            
            if (optionalpostid) {
              searchNumber = optionalpostid;
              //console.log("optionalpostid : " + optionalpostid);
            } else {
              searchNumber = 0;
              currentSvgSlidePageNumber++;
            }

            $.ajax({
              type: "POST",
              url: SiteParameters.ajax_url,
              dataType: 'html',
              data: ({
                action: 'loadMoreSVGSlides',
                slidesPerPage: currentSvgSlidesPerPage,
                slidesOffset: currentSvgSlideOffset,
                slidesPageNumber: currentSvgSlidePageNumber,
                optionalpostid: optionalpostid
              }),
              beforeSend : function () {
                $svgSlidesContainer.addClass('loading');
              },
              success: function(data) {
                var svgslidesdata = jQuery.parseJSON(data);
                if (svgslidesdata)  {
                  if (svgslidesdata.onlyonepost) {
                    currentSvgSlideOffset = currentSvgSlideOffset;
                  } else {
                    currentSvgSlideOffset = currentSvgSlideOffset + currentSvgSlidesPerPage;
                  }

                  $.each(svgslidesdata.svgslideritems, function(index, value) {
                    if ($("#svg-slider-item-id-" + value.svgslideritemid).length === 0) {
                      $('.svg-slider').slick('slickAdd',value.svgslideritemcontent);
                    }
                  });                      

                  // attach tooltips to slider links
                  if (Foundation.MediaQuery.atLeast('xlarge')) {
                    $('.overlay-item-link').each(function(i){
                      if (!($(this).hasClass('has-tip'))) {
                        $(this).foundation();
                      }
                    });
                  }

                  // attach click handlers to open popup and scroll to selected slide
                  $('.overlay-item-link').click(function(){
                                        
                    var item_id = $(this).attr('data-indexnum');
                    var $slickSlide = $('#overlay-slider-item-id-'+item_id);
                    var $slickSlideImage = $('#overlay-slider-item-id-'+item_id+ ' .popup-slide-main-image');
                    
                    load_overlay_slides(item_id, false);

                    $('#overlayModal').foundation('open');
                    return false;
                  });                    

                  // check for more posts
                  if (svgslidesdata.nomoreposts) {
                    $svgSlidesContainer.removeClass('loading').addClass('no-more-posts');
                  } else {
                    $svgSlidesContainer.removeClass('loading');
                  }

                } else {
                  console.log("no data");
                }
              },
              error: function(data) {
                console.log("Error: " + data);
                return false;
              },
              complete: function() { 
                setTimeout(function(){
                  if (searchNumber !== 0) {
                    var $slickSlide = $('#svg-slider-item-id-' + searchNumber);
                    var slideIndex = $slickSlide.attr('data-slick-index');             
                    $('.svg-slider').slick('slickGoTo', slideIndex, true);
                    $('#svg-slider-item-id-' + searchNumber + ' .overlay-item-link').foundation('show');
                  } 
                }, 500);  
              }
            });
          }
    
          return false; 
        }

        // On svg-slider init
        $('.svg-slider').on('init', function(event, slick) {

          load_more_svg_slides(); 

          setTimeout(function(){
            var $svgSlideImages = $(".svg-slide-image");   
            $.each($svgSlideImages, function() {
              var $this = $(this);
              if (!($this.hasClass('img-loaded'))) {
                $this.attr("xlink:href", $this.attr('data-img'));
                $this.addClass('img-loaded');
              }
            });    

            $('.fade-in').css({'opacity': 1}); 

          }, 500);   

        }); 

        // On svg-slider setPosition
        $('.svg-slider').on('setPosition', function(event, slick) {
             
        });

        // On svg-slider beforeChange
        $('.svg-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){ 
                  
        }); 

        // On svg-slider afterChange, load images
        $('.svg-slider').on('afterChange', function(event, slick, currentSlide){
          var $svgSlideImages = $(".svg-slide-image");   
          $.each($svgSlideImages, function() {
            var $this = $(this);
            if (!($this.hasClass('img-loaded'))) {
              $this.attr("xlink:href", $this.attr('data-img'));
              $this.addClass('img-loaded');
            }
          });          
        });  


        $('.svg-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){ 
          var slidesToShow;
          if(slick.activeBreakpoint!==null){
            slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
          } else {
            slidesToShow = slick.options.slidesToShow;
          }
          var loadingPoint = (slick.currentSlide+slidesToShow)/slidesToShow + 1;
          var numSlides = Math.ceil((slick.slideCount)/slidesToShow);
  
          if (loadingPoint === numSlides) {
              load_more_svg_slides();
          }
                  
        }); 
                     
        // Load overlay slides
        var $overlayLoader = $('.overlay-loader');
    
        function load_overlay_slides(overlaypostid, addposition) {
    
          if (!($overlayLoader.hasClass('loading'))) {

            $.ajax({
              type: "POST",
              url: SiteParameters.ajax_url,
              dataType: 'html',
              data: ({
                action: 'loadOverlaySlides',
                overlaypostid: overlaypostid
              }),
              beforeSend : function () {
                $overlayLoader.addClass('loading');
              },
              success: function(data) {
                var overlayslidesdata = jQuery.parseJSON(data);
                
                if (overlayslidesdata)  {

                  $.each(overlayslidesdata.overlayslideritems, function(index, value) {
                    if ($("#overlay-slider-item-id-" + value.overlayslideritemid).length === 0) {
                      $('.overlay-slider').slick('unslick');
                      // add slide to start or to end of slides
                      if (addposition)
                      {
                        $('.overlay-slider').prepend(value.overlayslideritemcontent);
                      }
                      else
                      {
                        $('.overlay-slider').append(value.overlayslideritemcontent);
                        
                      }
                      $('.overlay-slider').foundation();
                      $('.overlay-slider').slick(overlay_opts);
                    }
                  });

                  var move_to = $('#overlay-slider-item-id-' + overlaypostid).attr('data-slick-index');
                  $('.overlay-slider').slick('slickGoTo',move_to, true);

                  var previous_item_id = $('#overlay-slider-item-id-' + overlaypostid).attr('data-previous-post');
                  var next_item_id = $('#overlay-slider-item-id-' + overlaypostid).attr('data-next-post');
                 
                  if (previous_item_id) {
                    $('.overlay-slick-previous').removeClass('no-more-posts');
                  } else {
                    console.log('no more previous posts');
                    $('.overlay-slick-previous').addClass('no-more-posts');
                  }                
                  if (next_item_id) {
                    $('.overlay-slick-next').removeClass('no-more-posts');
                  } else {
                    console.log('no more next posts');
                    $('.overlay-slick-next').addClass('no-more-posts');
                  }
                  /*
                  var $slickSlide = $('#overlay-slider-item-id-' + overlaypostid);
                  var slideIndex = $slickSlide.attr('data-slick-index');   
                  $('.overlay-slider').slick('slickGoTo', slideIndex);
                  */
                  
                  $overlayLoader.removeClass('loading');
              
                } else {
                  console.log("no data");
                }
              },
              error: function(data) {
                console.log("Error: " + data);
                return false;
              },
              complete: function() {     

              }
            });
          }
    
          return false; 
        }

        // Every time Slick (re-)initializes callback
        $('.overlay-slider').on('reInit', function(event, slick){
          //console.log("reInit");
        });

        // On overlay-slider before slide change
        $('.overlay-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
       
        });

        $('.overlay-slider').on('afterChange', function(event, slick, currentSlide){
        
        });


        $('#overlayModal').on('open.zf.reveal', function() {

        }); 

        $('#overlayModal').on('closed.zf.reveal', function() {
          $('.overlay-slider').slick('removeSlide', null, null, true);
        });    

        
        $(".overlay-slider-wrapper" ).on( "click", ".overlay-slick-previous", function(ev)
        {
          ev.preventDefault();
          var previous_item_id = $('.overlay-slide.slick-current').attr('data-previous-post');
          if (previous_item_id) {
            load_overlay_slides(previous_item_id, true);
            $('.overlay-slider').slick('slickPrev');
          }
        });


        $(".overlay-slider-wrapper" ).on( "click", ".overlay-slick-next", function(ev)
        {
          ev.preventDefault();
          var next_item_id = $('.overlay-slide.slick-current').attr('data-next-post');
            if (next_item_id) {
              load_overlay_slides(next_item_id, false);
              $('.overlay-slider').slick('slickNext');
            }            
        });              

        // Load ajax posts
        var currentPostsPerPage = 10;
        var currentOffset = 0;
        var currentPageNumber = 0;
        var $postsContainer = $('.post-items');
        var $loader = $('#morePosts');

        function load_ajax_posts() {

          if (!($loader.hasClass('loader-loading') || $loader.hasClass('loader-no-more-posts'))) {
            currentPageNumber++;

            $.ajax({
              type: "POST",
              url: SiteParameters.ajax_url,
              dataType: 'html',
              data: ({
                action: 'loadMorePosts',
                postsPerPage: currentPostsPerPage,
                offset: currentOffset,
                pageNumber: currentPageNumber
              }),
              beforeSend : function () {
                $loader.addClass('loader-loading').text('Loading ...');
              },
              success: function(data) {
                var gallerydata = jQuery.parseJSON(data);
                if (gallerydata)  {
                  currentOffset = currentOffset + currentPostsPerPage;

                  $postsContainer.append(gallerydata.galleryitems);                      
                  
                  $.each(gallerydata.galleryslideritems, function(index, value) {
                    $('.gallery-slider').slick('slickAdd',value);
                  });

                  // attach click handlers to open popup and scroll to selected slide
                  $('.gallery-item-link').click(function(){
                    var item_id = $(this).attr('data-indexnum');
                    var $slickSlide = $('#gallery-slider-item-id-'+item_id);
                    var slideIndex = $slickSlide.attr('data-slick-index');
                    $('.gallery-slider').slick('slickGoTo', slideIndex, true);
                    $('#galleryModal').foundation('open');                                    
                    return false;
                  });                    

                  // check for more posts
                  if (gallerydata.nomoreposts) {
                    $loader.removeClass('loader-loading').addClass('loader-no-more-posts hide').text('No more posts...');
                  } else {
                    $loader.removeClass('loader-loading').text('Mehr anzeigen');
                  }

                } else {
                  console.log("no data");
                }                
              },
              error: function(data) {
                console.log("Error :( " + data);
                return false;
              }
            });
          }

          return false; 
        }
 
        // On gallery-slider init, load ajax posts
        $('.gallery-slider').on('init', function(event, slick) {
          load_ajax_posts();
        });              
        $loader.on( 'click', load_ajax_posts );

        // On gallery-slider before slide change load more posts
        $('.gallery-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          var gallerySlidesLength = slick.slideCount;
          if ((gallerySlidesLength - 1) === nextSlide && (!($loader.hasClass('loader-loading') || $loader.hasClass('loader-no-more-posts')))) {
            load_ajax_posts();
          }
        }); 

        // resize gallery-slider after opening modal
        $('#galleryModal').on('open.zf.reveal', function() {
          $('.gallery-slider').slick('setPosition');
        }); 

        // scroll to current gallery item after closing modal
        $('#galleryModal').on('closed.zf.reveal', function() {
          var currentGalleryItemID = $('.gallery-slider').find(".slick-active").attr('data-slide-num');
          var currentGalleryItem = $('#gallery-item-id-' + currentGalleryItemID);

          $('html, body').animate({
              scrollTop: currentGalleryItem.offset().top
          }, 500);         
        });          

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired  
     
       
      },
      resize: function() {

        var headerHeight = $('#main-header').outerHeight(true);
        var footerHeight = $("#footer-wrap").outerHeight(true);
        var windowHeight = 0;
        if ($('#main-header').hasClass('head-section-type-bg-gallery')) {
          windowHeight = $(window).height();
        } else {
          windowHeight = $(window).height() - headerHeight;
        }
        var fullWinHeight = $(window).height() - headerHeight - footerHeight;

        // move head-section-sub-headline
        if (Foundation.MediaQuery.atLeast('xlarge')) {
          $( ".head-section-sub-headline" ).appendTo( $( ".head-section-wrap" ) );
          //$('.tooltip').css('display', "none"); 
        } else {
          $( ".head-section-sub-headline" ).appendTo( $( ".total-length-wrap" ) );
          //$('.tooltip').css('display', "none !important"); 
        }       

        // Sliders
        var resizeSliders = null;

        clearTimeout(resizeSliders);
        resizeSliders = setTimeout(
          function() {
            function renderCounter(slick,carouselId) {
              var slidesToShow;
              if(slick.activeBreakpoint!==null){
                slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
              } else {
                slidesToShow = slick.options.slidesToShow;
              }
    
              if($('#'+carouselId).parents('.slider-wrapper').find('.slick-next').length>0){
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html( (slick.currentSlide+slidesToShow)/slidesToShow +' / ' + Math.ceil((slick.slideCount)/slidesToShow));
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').show();
              } else {
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html('');
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').hide();
              }
            } 
    
            $('.common-slider').each(function (idx, item) {
              if ($(this).hasClass('slick-initialized')) {
                  $(this).slick('resize');
              } else {
                var carouselId = "carousel_" + idx;
                this.id = carouselId;
                $(this).attr('data-counter','carousel_slick-control_' + idx);
                $(this).next('.slider-control').attr('id','carousel_slick-control_' + idx);
                
                $(this).on('init', function(event, slick) {
                  //console.log('init');
                });
    
                $(this).on('setPosition', function(event, slick) {
                  //console.log('setPosition');
                  renderCounter(slick,carouselId);
                });
    
                $(this).on('afterChange', function(event, slick, currentSlide){
                  //console.log('afterChange');
                });  

                $(this).on('edge', function(event, slick, direction){
                  console.log('edge was hit');
                });                          
    
                $(this).slick();

              }
            }); 

          },
          400
        );

        // set height of head-section type-bg-gallery
        var galleryHeadSectionMinHeight = $(".head-section .head-section-upper-wrap").outerHeight(true) + $(".head-section .svg-slider-wrap").outerHeight(true) + $(".head-section .scrolldown-wrap").outerHeight(true) + 170;
        var headSectionUpperWrapPadding = windowHeight - galleryHeadSectionMinHeight;
  
        if ((Foundation.MediaQuery.atLeast('xlarge')) && (galleryHeadSectionMinHeight < windowHeight) && (windowHeight < 1000)) {
          $(".head-section.type-bg-gallery").addClass('height-set');
          $(".head-section.type-bg-gallery").css({'height': windowHeight});
          $(".head-section-upper-wrap").css({'padding-bottom': headSectionUpperWrapPadding});
          $('.scrolldown-wrap').show();
        } else {
          $(".head-section.type-bg-gallery").removeClass('height-set');
          $(".head-section.type-bg-gallery").css({'height': 'auto'});
          $(".head-section-upper-wrap").css({'padding-bottom': '0px'});
          $('.scrolldown-wrap').hide();
        }      

        // Sticky footer
        function stickyFooter() {
          if (Foundation.MediaQuery.atLeast('large')) {
            var combinedHeight = windowHeight - footerHeight;
            $("main.main").css('min-height', combinedHeight + "px");
          } else {
            $("main.main").css('min-height', "100vh");          
          }                    
        }

        if ($( "#footer-wrap" ).length) {
          stickyFooter();
        }       

      },
      windowload: function() {
        //console.log('loaded');
        $('html').addClass('wf-active');
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        function getBgUrl(el) {
            var bg = "";
            if (el.currentStyle) { // IE
                bg = el.currentStyle.backgroundImage;
            } else if (document.defaultView && document.defaultView.getComputedStyle) { // Firefox
                bg = document.defaultView.getComputedStyle(el, "").backgroundImage;
            } else { // try and get inline style
                bg = el.style.backgroundImage;
            }
            return bg.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
        }
        
        var image = document.createElement('img');
        image.src = getBgUrl(document.getElementById('landscape'));
        image.onload = function () {
            $('#landscape').css({'opacity': 1});
        };

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      },
      resize: function() {

      },
      windowload: function() {

      }
    },
    'page_template_template_layouts': {
      init: function() {

      },
      finalize: function() {

      },
      resize: function() {

      },
      windowload: function() {

      }
    }    
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        //UTIL.fire(classnm, 'resize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
      //UTIL.fire('common','resize');
    },
    resizeEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'resize');
      });

      UTIL.fire('common','resize');

    },
    windowLoadEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm, 'windowload');
      });

      UTIL.fire('common','windowload');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  $(window).resize(UTIL.resizeEvents);
  $(window).on("load",UTIL.resizeEvents);
  $(window).on("load",UTIL.windowLoadEvents);


})(jQuery); // Fully reference jQuery after this point.

